<template>
  <button class="btn btn-sm btn-secondary" @click="show"><font-awesome-icon icon="question"/> {{$t('addFailedContact')}}
    <b-modal v-model="showForm" :title="$t('addFailedContact')" @ok="updateFailedContact">
      <form-input :model="formModel" attribute="phone" :errors="formErrors" :placeholder="$t('phone')"></form-input>
      <form-input :model="formModel" attribute="sendErrorMsg" :errors="formModel" :placeholder="$t('sendErrorMsg')"></form-input>
    </b-modal>
  </button>
</template>

<script>
export default {
  props: ['campaign'],
  data: function () {
    return {
      showForm: false,
      formModel: {
        phone: null
      },
      formErrors: []
    }
  },
  methods: {
    show() {
      this.formModel = {
        phone: null
      };
      this.showForm = true;
    },
    updateFailedContact(evt) {
      evt.preventDefault();
      if (!this.formModel.phone) {
        this.formErrors.push({param: "phone", msg: this.$t('phoneMustNotBeEmpty'), location: "body"})
        return false;
      } else {
        this.$swal({
          title: this.$t('updateConfirm', [this.formModel.phone]),
          icon: "info",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            let loader = this.$loading.show();
            this.$service({url: 'message-campaign/add-failed-contact/'+ this.campaign, method: 'post', data: this.formModel}).then(response => {
              if (response.data) {
                this.showForm = false;
                this.$swal({
                  title: this.$t('updateSuccess'),
                  icon: 'success',
                  toast: true,
                  position: 'top-end',
                  timer: 5000,
                });
                this.$bus.$emit('loadSMSCampaign');
              } else {
                this.$swal({
                  title: this.$t('error'),
                  text: this.$t('updateFailed'),
                  icon: 'error'
                });
              }
            }).catch(error => {
              if (error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: 'error'
                });
              } else {
                this.$swal({
                  text: error.response.data[0].msg,
                  icon: 'error'
                });
              }
            }).finally(() => {
              loader.hide();
            });
          }
        });
      }
    }
  },
  i18n: {
    messages: {
      en: {
        addFailedContact: 'Add failed contact',
        phoneMustNotBeEmpty: 'Phone must not be empty',
        updateConfirm: 'Are you sure to mark number {0} as failed to send?',
        updateSuccess: 'Contact updated!',
        updateFailed: 'Fail to update contact',
        sendErrorMsg: 'Error message'
      },
      vi: {
        addFailedContact: 'Cập nhật LH lỗi',
        phoneMustNotBeEmpty: 'SĐT không được bỏ trống',
        updateConfirm: 'Bạn có chắc muốn đánh dấu liên hệ {0} là gửi thất bại?',
        updateSuccess: 'Liên hệ đã được cập nhật',
        updateFailed: 'Cập nhật thất bại',
        sendErrorMsg: 'Lý do lỗi'
      }
    }
  }
}
</script>